export default __webpack_public_path__ + "static/media/BNB-grey.9b01de89.svg";